import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/other`;

export interface SetSellerConfigurationOtherCommandArgs {
  sellerId: string;
  cgvUrl?: string;
  faqUrl?: string;
  lowValueThreshold?: {
    amount: number;
    currency: string;
  };
  automatedMessagesEnabled?: boolean;
  isClaimValidationNeeded?: boolean;
  defaultOwnerOrderUrl?: string;
  ownerNotificationSenderMail?: string;
  paymentUrl?: string;
  qualiReparUrl?: string;
  isCashRegisterConnected: boolean;
  vonageNaming?: string;
  ianaTimeZoneName?: string;
  includedMargin?: boolean;
}

export default async function setSellerConfigurationOtherCommand(
  payload: SetSellerConfigurationOtherCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const { sellerId, ...json } = payload;
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
      json,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
